import { BRAND, type ColorMode } from '@chukua/common';
import type { Map as MapLibreMap } from 'maplibre-gl';
import { TerraDraw, TerraDrawPointMode, TerraDrawPolygonMode, TerraDrawSelectMode, type HexColor } from 'terra-draw';
import { TerraDrawMapLibreGLAdapter } from 'terra-draw-maplibre-gl-adapter';

/**
 * terra-draw on the Zones map, for the one zone whose panel is open. Select mode is configured to edit
 * what is already there: drag a corner, drag a midpoint to add one, remove a corner, or move the whole shape.
 */
export function createZoneDraw(map: MapLibreMap, mode: ColorMode): TerraDraw {
  // The zone being edited stands out from the kind-coloured zones around it in the accent terracotta.
  const editColor = BRAND.palettes[mode].accent as HexColor;
  const handleColor = BRAND.palettes[mode].surface as HexColor;
  const adapter = new TerraDrawMapLibreGLAdapter({ map });
  return new TerraDraw({
    adapter,
    modes: [
      new TerraDrawPolygonMode({ styles: { fillColor: editColor, fillOpacity: 0.3, outlineColor: editColor, outlineWidth: 3 } }),
      new TerraDrawPointMode({ styles: { pointColor: editColor, pointWidth: 7, pointOutlineColor: handleColor, pointOutlineWidth: 2 } }),
      new TerraDrawSelectMode({
        flags: {
          polygon: { feature: { draggable: true, coordinates: { draggable: true, midpoints: true, deletable: true } } },
          point: { feature: { draggable: true } },
        },
        styles: {
          selectedPolygonColor: editColor,
          selectedPolygonFillOpacity: 0.3,
          selectedPolygonOutlineColor: editColor,
          selectedPolygonOutlineWidth: 3,
          selectedPointColor: editColor,
          selectedPointOutlineColor: handleColor,
          selectionPointColor: handleColor,
          selectionPointOutlineColor: editColor,
          midPointColor: editColor,
          midPointOutlineColor: handleColor,
        },
      }),
    ],
  });
}
